const enterNumber = (el: any, binding: any, vNode: any) => {
  const element = el.getElementsByTagName('input')[0];
  element.onkeyup = function() {
    if (element.value.length == 1) {
      element.value = element.value.replace(/[^1-9]/g, '');
    } else {
      element.value = element.value.replace(/[^\d]/g, '');
    }
    vNode.data.model.callback(element.value);
  };
  element.blur = function() {};
};
export default enterNumber;
